<template>
    <Breadcrumbs main="Buttons" title="Raised Buttons" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <raisedsButtons />
                <raisedsButtons2 />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const raisedsButtons = defineAsyncComponent(() => import("@/components/theme/buttons/raised/raisedsButtons.vue"))
const raisedsButtons2 = defineAsyncComponent(() => import("@/components/theme/buttons/raised/raisedsButtons2.vue"))

</script>